import React, {useState} from 'react'
import {makeStyles} from "@mui/styles";
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import {CardHeader, Collapse, Icon, IconButton, Typography} from "@mui/material";
import {ExpandMore, FavoriteBorder, MenuBook, PeopleOutline, Visibility} from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 450,
        width: "100%",
        minWidth: "250px",
        height: "auto",
        marginTop: "1vh",
        marginBottom: "1vh",
        borderRadius: 0,
    },
    media: {
        position: 'relative',
        width: "100%",
        height: 0,
        paddingTop: "100%",
    },
    mediaDetails: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 8,
        background: '#f5f5f5',
        padding: '2px 8px',
    },
    mediaDetail: {
        minWidth: 35,
        textAlign: 'center',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    title: {
        maxHeight:"4em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkitLineClamp": 2,
        "-webkitBoxOrient": "vertical"
    }
}));

export default function UserCardSmall({user, recipeClick}) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);
    const username = user.username ? user.username : user.id;
    const displayName = username ? username.charAt(0).toUpperCase() + username.slice(1).toLowerCase() : '';

    return (
        <Card variant="outlined" className={classes.card}>
            <div onClick={recipeClick} style={{cursor: 'pointer'}}>
                <CardHeader
                    style={{paddingLeft: 8, paddingTop: 6, paddingBottom: 4}}
                    titleTypographyProps={{variant: "body1", className: classes.title}}
                    title={displayName}
                />
                <CardMedia
                    className={classes.media}
                    image={user.imageData ? user.imageData : process.env.PUBLIC_URL+"/notFoundImage.svg"}
                    style={user.imageData ? {} : {backgroundSize: "50%"}}
                    title={displayName}
                >
                    <div className={classes.mediaDetails}>
                        <div className={classes.mediaDetail} style={{marginLeft: -4}}>
                            <Icon color="secondary" style={{overflow: 'visible'}}>
                                <MenuBook/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 30)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <PeopleOutline/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 100)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <FavoriteBorder/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 200)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <Visibility/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 500)}</Typography>
                        </div>
                    </div>
                </CardMedia>
                <div style={{display: 'flex', alignItems: 'center', padding: '4px 8px 0'}} onClick={(e) => e.stopPropagation()}>
                    <Typography variant="caption" color="textSecondary" component="p">
                        {user.about ? user.about.substring(0, 50) + (user.about.length > 50 ? '...' : '') : "No bio yet."}
                    </Typography>
                    <IconButton size="small" onClick={() => setExpanded(!expanded)} style={{marginLeft: 'auto'}}>
                        <ExpandMore style={{transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s'}}/>
                    </IconButton>
                </div>
            </div>
            <Collapse in={expanded}>
                <div style={{padding: '0 8px 8px'}}>
                    <Typography variant="caption" color="textSecondary" component="p" style={{paddingTop: 4}}>
                        {user.about ? user.about : "No bio yet."}
                    </Typography>
                </div>
            </Collapse>
        </Card>
    )
}
